import BaseModel from '../BaseModel';
import * as AT from '@hit/base/src/components/container/attributes';

export default class Tag extends BaseModel {
  constructor({id, designation, userId = null}) {
    super(id, null, designation);
    this.userId = userId;
  }

  get icon() {
    if (this.userId) {
      return 'user';
    }
    return 'group_on';
  }

  static get fkName() {
    return 'tag_id';
  }
  static get apiRoute() {
    return 'tag';
  }
  static get detailPageRoute() {
    return 'CommonTagList';
  }
  static get listPageRoute() {
    return 'CommonTagList';
  }
  get fkName() {
    return Tag.fkName;
  }
  get apiRoute() {
    return Tag.apiRoute;
  }
  get listPageRoute() {
    return Tag.listPageRoute;
  }
  get detailPageRoute() {
    return Tag.detailPageRoute;
  }

  static get orderKey() {
    return 'designation';
  }
  static get orderOrder() {
    return 'asc';
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['designation']);
  }

  static get listDisplayAttrs() {
    return this.getAttributes(
      [
        'designation',
        'address',
        'transaction',
        'staff',
        'resource',
        'purchase',
        'equipment',
        'project',
        'projectPartItem',
        'projectPartBill',
        'form',
        'action',
        'projectContract',
        'colour',
        'creationDate',
        'modificationDate',
      ],
      ['userId'],
    );
  }

  static get entityActiveAttrs() {
    return this.getAttributes([
      'address',
      'transaction',
      'staff',
      'resource',
      'purchase',
      'equipment',
      'project',
      'projectPartItem',
      'projectPartBill',
      'form',
      'action',
      'projectContract',
    ]);
  }

  static get allAttributes() {
    return [
      this.DESIGNATION_ATTRIBUTE(),
      this.ACTIVE_ATTRIBUTE(),
      new AT.ColourAttribute({
        name: 'colour',
        tableProperties: {
          header: 'hit-app.common.colour',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'address',
        column: 'address_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.address',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'transaction',
        column: 'transaction_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.transaction',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'staff',
        column: 'staff_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.staff',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'resource',
        column: 'resource_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.resource',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'purchase',
        column: 'purchase_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.purchase',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'equipment',
        column: 'equipment_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.equipment',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'project',
        column: 'project_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.project',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'projectPartItem',
        column: 'project_part_item_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.project-part-item',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'projectPartBill',
        column: 'project_part_bill_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.project-part-bill',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'form',
        column: 'form_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.form',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'action',
        column: 'action_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.action',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'projectContract',
        column: 'project_contract_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.project-contract',
          maxWidth: '0.5fr',
        },
      }),
      new AT.StringAttribute({
        name: 'userId',
        column: 'user_id',
        default: null,
      }),
      new AT.DateAttribute({
        name: 'creationDate',
        column: 'creation_date',
        tableProperties: {
          header: 'hit-base.common.creation-date',
          hideByDefault: true,
        },
      }),
      new AT.DateAttribute({
        name: 'modificationDate',
        column: 'modification_date',
        tableProperties: {
          header: 'hit-base.common.last-modified',
          hideByDefault: true,
        },
      }),
    ];
  }
}
